@switch (size) {
  @case (BaseConfirmPromptSize.SM) {
    <div
      class="flex flex-col justify-center content-center items-center w-full md:w-[30rem]"
    >
      @switch (type) {
        @case (BaseConfirmPromptType.DEFAULT) {
          <div class="w-full">
            <button
              class="w-[2.5rem] h-[2.5rem] p-0 float-right"
              edType="tertiary"
              (click)="onCloseClick()"
              ed-button
            >
              <mat-icon
                class="w-[0.5rem] h-[0.5rem]"
                svgIcon="close"
              ></mat-icon>
            </button>
          </div>
        }
        @case (BaseConfirmPromptType.INVITE) {
          <div class="w-full flex justify-between items-center">
            <div class="font-bold text-lg">
              {{ title }}
            </div>
            <button
              class="w-[2.5rem] h-[2.5rem] p-0 float-right"
              edType="tertiary"
              (click)="onCloseClick()"
              ed-button
            >
              <mat-icon
                class="w-[0.5rem] h-[0.5rem]"
                svgIcon="close"
              ></mat-icon>
            </button>
          </div>
        }
      }

      <div
        class="flex flex-col justify-center content-center items-center w-full"
      >
        @if (!hideIcon) {
          <div class="m-3">
            @if (!icon) {
              <div class="card-icon-external-layer">
                <div class="card-icon-middle-layer">
                  <div class="card-icon-inner-layer">
                    <mat-icon
                      class="absolute"
                      svgIcon="message-question2"
                    ></mat-icon>
                  </div>
                </div>
              </div>
            } @else {
              <mat-icon class="custom-icon" [svgIcon]="icon"></mat-icon>
            }
          </div>
        }
        @if (type === BaseConfirmPromptType.DEFAULT) {
          <div class="font-bold text-lg text-center p-1">
            {{ title }}
          </div>
        }
        <div class="w-full my-3 text-center">
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </div>
      </div>
      <div
        class="flex gap-3"
        [ngClass]="{
          'flex-col': type === BaseConfirmPromptType.DEFAULT,
          'flex-row-reverse w-full': type === BaseConfirmPromptType.INVITE,
        }"
      >
        <button
          [disabled]="disableConfirmButton"
          class="w-[7.375rem]"
          edType="primary"
          edSize="large"
          (click)="onConfirmClick()"
          ed-button
        >
          {{ confirmBtnLabel | transloco }}
        </button>
        <button
          class="w-[7.375rem]"
          edType="secondary"
          edSize="large"
          (click)="onCloseClick()"
          ed-button
        >
          {{ cancelBtnLabel | transloco }}
        </button>
      </div>
    </div>
  }
  @case (BaseConfirmPromptSize.MD) {
    <div class="flex flex-col md:w-[60vw] lg:w-[50rem]">
      <div class="flex flex-row w-full">
        <div class="text-lg font-bold items-center">
          {{ title }}
        </div>
        <div class="grow">
          <button
            class="w-[2.5rem] h-[2.5rem] p-0 float-right"
            edType="tertiary"
            (click)="onCloseClick()"
            ed-button
          >
            <mat-icon class="w-[0.5rem] h-[0.5rem]" svgIcon="close"></mat-icon>
          </button>
        </div>
      </div>
      <div class="w-full my-3">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
      <div class="flex flex-row-reverse gap-3">
        <button
          [disabled]="disableConfirmButton"
          class="w-[7.375rem]"
          edType="primary"
          edSize="large"
          (click)="onConfirmClick()"
          ed-button
        >
          {{ confirmBtnLabel | transloco }}
        </button>
        <button
          class="w-[7.375rem]"
          edType="secondary"
          edSize="large"
          (click)="onCloseClick()"
          ed-button
        >
          {{ cancelBtnLabel | transloco }}
        </button>
      </div>
    </div>
  }
}
